import type { SignupData } from '@mogul/api-client';
import React, { useContext } from 'react';

import { useAuth } from '../../../auth';
import { RegisterComponent } from '../../../components/register/Register.component';
import { ModalStateContext } from '../../../contexts/app-state-context/modal-state.context';

export const RegisterPage: React.FC = () => {
  const { signup } = useAuth();

  const { setModal } = useContext(ModalStateContext);

  const onSignupPress = (data: SignupData) => {
    return signup(data);
  };

  return (
    <RegisterComponent setModal={setModal} onSignupPress={onSignupPress} />
  );
};
